import React from 'react';
import { Alert, Box } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import { useTheme } from '@mui/material/styles';

function SimpleAlert({ text, showAlert, type }) {
  const theme = useTheme();

  const getIcon = (type) => {
    if (type === "success") {
      return <CheckIcon fontSize="inherit" />;
    } else {
      return <PersonOffIcon fontSize="inherit" />;
    }
  };

  if (!showAlert) return null;

  return (
    <Box sx={{
      position: 'fixed',
      top: '70px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '70%',
      zIndex: 1000,
      boxShadow: `0 2px 4px ${theme.palette.component.borderColor}`,
    }}>
      <Alert icon={getIcon(type)} severity={type === "success" ? "success" : "error"}>
        {text}
      </Alert>
    </Box>
  );
}

export default SimpleAlert;